// extracted by mini-css-extract-plugin
export var layoutContainer = "_cv-0";
export var layoutContainerNoRounding = "_cv-6";
export var layoutContainerOpen = "_cv-5";
export var layoutContainerResizing = "_cv-1";
export var mainContent = "_cv-2";
export var resizeDivider = "_cv-3";
export var slidePanel = "_cv-4";